import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="webhook-events-toggle"
//
// Wires three layers of checkbox: a global "All events", one "All X" per
// category, and the individual event checkboxes. Clicking an aggregate toggles
// its children; clicking a child re-syncs aggregates upwards (including the
// indeterminate state when some-but-not-all children are checked).
export default class extends Controller {
  static targets = ["all", "categoryAll", "event"]

  connect() {
    this.syncAggregates();
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.eventTargets.forEach((el) => { el.checked = checked; });
    this.categoryAllTargets.forEach((el) => {
      el.checked = checked;
      el.indeterminate = false;
    });
    this.allTarget.indeterminate = false;
  }

  toggleCategory(event) {
    const wrapper = event.target.closest("[data-webhook-events-toggle-category]");
    if (!wrapper) return;

    const checked = event.target.checked;
    wrapper.querySelectorAll('[data-webhook-events-toggle-target="event"]')
      .forEach((el) => { el.checked = checked; });
    event.target.indeterminate = false;
    this.syncTopLevel();
  }

  syncAggregates() {
    this.categoryAllTargets.forEach((catCheckbox) => {
      const wrapper = catCheckbox.closest("[data-webhook-events-toggle-category]");
      if (!wrapper) return;
      const events = wrapper.querySelectorAll('[data-webhook-events-toggle-target="event"]');
      this.applyAggregateState(catCheckbox, events);
    });
    this.syncTopLevel();
  }

  syncTopLevel() {
    this.applyAggregateState(this.allTarget, this.eventTargets);
  }

  applyAggregateState(aggregate, children) {
    const total = children.length;
    const checked = Array.from(children).filter((el) => el.checked).length;

    if (total === 0 || checked === 0) {
      aggregate.checked = false;
      aggregate.indeterminate = false;
    } else if (checked === total) {
      aggregate.checked = true;
      aggregate.indeterminate = false;
    } else {
      aggregate.checked = false;
      aggregate.indeterminate = true;
    }
  }
}
